var $307a0e76da0f5153$exports = {};
$307a0e76da0f5153$exports = {
    "info": `Informatie`,
    "negative": `Fout`,
    "notice": `Waarschuwing`,
    "positive": `Geslaagd`
};


export {$307a0e76da0f5153$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
